import { Component, OnInit } from '@angular/core';
import { SidebarItemModel } from '../../models/sidebar-item.model';
import * as fromSidebar from '../../store/reducers/sidebar.reducer';
import * as fromAuth from '../../../store';
import * as fromSelectors from '../../store/selectors';
import { Store, select } from '@ngrx/store';
import * as fromActions from '../../store/actions';
import { mappingRoleSidebar } from './utils/mapping-role-sidebar';
import { Role } from 'src/app/shared/models/role';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  items: SidebarItemModel[];
  currentRole: Role;

  constructor(
    private store: Store<fromSidebar.SidebarState>,
    private storeAuth: Store<fromAuth.AuthState>,
    private router: Router
  ) { }

  ngOnInit() {

    this.storeAuth.pipe(select(fromAuth.selectSessionCurrentrole))
      .subscribe(currentRole => this.currentRole = currentRole);

    this.store.pipe(select(fromSelectors.getSidebar))
      .subscribe(sidebar => {
        if (sidebar.loaded) {
          const itemsByUser: string[] = mappingRoleSidebar[this.currentRole.code];
          this.items = itemsByUser.map((item) => sidebar.items.filter((menuItem) => menuItem.description === item))
            .reduce((acc, val) => acc.concat(val), []);
          this.navigateToHome(this.items);
        }

      });
    this.store.dispatch(fromActions.loadSidebar());
  }

  navigateToHome(items: SidebarItemModel[]) {
    if (items.length > 0) {
      const url = items[0].url;
      this.router.navigate([url]);
    }
  }

}
